import { Toaster, TooltipProvider } from "@gearbox-protocol/deploy-tools-ui";
import { AuthProvider } from "api";
import { VersionProvider } from "hooks/useVersion";
import type { FC } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { rootRoute } from "routes";

const rootRouter = createBrowserRouter([
  {
    path: "/",
    ...rootRoute,
  },
]);

const App: FC = () => (
  <VersionProvider>
    <TooltipProvider>
      <AuthProvider>
        <RouterProvider router={rootRouter} />
      </AuthProvider>
      <Toaster />
    </TooltipProvider>
  </VersionProvider>
);

export default App;
